// @flow

import * as React from "react"

type Props = {}

export default class extends React.Component<Props> {
  handleKeyPress: (SyntheticKeyboardEvent<HTMLInputElement>) => void

  constructor(props: Props) {
    super(props)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  handleKeyPress(e: SyntheticKeyboardEvent<HTMLInputElement>) {
    const regex = /[0-9]/
    const valid =
      e.metaKey || // cmd/ctrl
      e.which <= 0 || // arrow keys
      e.which == 8 || // delete / backspace key
      regex.test(String.fromCharCode(e.which))
    if (!valid) {
      e.preventDefault()
    }
  }

  render() {
    return <input {...this.props} onKeyPress={this.handleKeyPress} />
  }
}
